import {request} from './index';

export type PaymentBaseType = {
  id: number;
  status: boolean;
};

export type PaymentCreateType = PaymentBaseType & {
  url: string;
};

export type PaymentType = PaymentBaseType & {
  result: { refId: string };
};

export async function fetchPayment(paymentId: number): Promise<PaymentType> {
  return await request(true, { url: `/transactions/payments/${paymentId}` });
}

export type CreatePaymentDataType = { order: number };

export async function createPayment({ order }: CreatePaymentDataType): Promise<PaymentCreateType> {
  return await request(true, {
    url: '/transactions/payments',
    method: 'POST',
    data: { order }
  });
}
